import { NOT_SET_VALUE } from '../../constant'

export const getListIdTableSavePortfolio = (data) =>
  data.map((item) => item.portfolioId)

export const convertDataTableSavePortfolio = (data) => {
  const ids = getListIdTableSavePortfolio(data)
  const objData = {}
  ids.forEach((id) => {
    objData[id] = { ...data.find((item) => item.portfolioId === id) }
  })
  return objData
}

export const convertTypeAlert = (data) =>
  [
    NOT_SET_VALUE,
    ...data?.map((item) => ({
      ...item,
      label: item?.profileName,
      value: item?.alertProfileId,
      disabled: !item?.isDefault && item?.disabled,
    })),
  ].filter((item) => !item?.isFollowingList)

export const getDataSizeTable = (data, prev) => ({
  ...prev,
  totalRecords: data?.totalRecords,
  totalPage: data?.totalPage,
})
